<span class="priceIcon">
    <table [style]="priceViewService.viewPrice?'color:gray !important;':''" style="vertical-align: middle;" (click)="toggle()">
        <tr>
            <td style="vertical-align: middle;"><mat-icon class="eye-icon">remove_red_eye</mat-icon></td>
            <td style="vertical-align: middle;"><span class="nisIcon">₪</span></td>
        </tr>
    </table>
</span>
